import * as React from 'react';
import { baseUrlUser } from '../../../../constants/url.constant';
import DisplayStarRatingView from '../../../common/views/DisplayStarRatingView';
import { Utils } from '../../../common/views/Utils';
import { KeyValue } from '../../../home/models/OtherTypes';
import { OrderRequestType } from '../../../orders/models/OrderModel';
import { CustomerFilterType, CustomerLevel, CustomerType, ShortCustomerModel } from '../../models/CustomerModel';

type CustomerRowProps = {
    customer: ShortCustomerModel;
    filterType: CustomerFilterType;
}

export default function CustomerRowView({ customer, filterType }: CustomerRowProps) {
    const width2 = Utils.getColumnWidth(2);
    const width5 = Utils.getColumnWidth(5);
    const image = baseUrlUser + customer.imageUrl;

    const pointText = () => {
        return <div>{customer.totalPoint} points</div>;
    }

    const getRequestText = (type: OrderRequestType) => {
        if (type === OrderRequestType.scheduled) {
            return Utils.formatShortDate(customer.orderRequestDate);
        }

        return OrderRequestType[type];
    }

    const invoiceAvailableText = () => {
        return <div>
            {customer.orderDetails.map((info: KeyValue<OrderRequestType, number>) => {
                return <span>{Utils.splitCapitalCase(getRequestText(info.key))}: {info.value}</span>
            })}
        </div>;
    }

    const statusView = () => {
        return <div>
            {customer.isEmployee && <span>Employee</span>}
            {!customer.isEmployee && customer.isUser && <span>User</span>}
            {customer.level !== CustomerLevel.none && customer.level !== CustomerLevel.regular && <span className="pr-5">
                {CustomerLevel[customer.level]}
            </span>}

            {customer.type === CustomerType.wholesale && <span className="pr-5">Wholesale</span>}
        </div>;
    }

    return <div className="ms-Grid-row pv-5">
        <div className={width2}>
            {!Utils.isNullOrEmpty(customer.imageUrl) && <>
                <img src={image} alt="photo" style={{ width: 42, borderRadius: 50 }} />
            </>}
        </div>

        <div className={width5}>
            <div className="font-bold">
                {customer.displayName}
            </div>

            <div className="pv-5">
                {Utils.formatKhPhone(customer.countryCode, customer.phoneNo)}
            </div>

            {filterType === CustomerFilterType.invoiceAvailable && invoiceAvailableText()}
        </div>

        <div className={width5 + " right mt--5"}>
            {customer.grade > 0 && <div className="pt-5">
                <DisplayStarRatingView rating={customer.grade} maxRating={5} color={"black"} />
            </div>}

            {customer.orderTotal !== 0 && <div className="pt-5">
                Sale: ${customer.orderTotal.toFixed(2)}</div>}
            {customer.totalPoint !== 0 && <div className="pt-5">{pointText()}</div>}
            <div className="pt-5">{statusView()}</div>
        </div>
    </div>;
}